<template>
  <div class="gardenCompositionDetail">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws12" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="住宅套数" prop="residenceNum">
          <el-input v-model="ruleForm.residenceNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="住宅面积(㎡)" prop="residenceArea">
          <el-input v-model="ruleForm.residenceArea" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="非住宅套数" prop="notResidenceNum">
          <el-input v-model="ruleForm.notResidenceNum" placeholder="请输入" class="item-input" type="number"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="非住宅面积(㎡)" prop="notResidenceArea">
          <el-input v-model="ruleForm.notResidenceArea" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="物业管理用房套数" prop="wyHouseNum">
          <el-input v-model="ruleForm.wyHouseNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="物业管理用房面积(㎡)" prop="wyHouseArea">
          <el-input v-model="ruleForm.wyHouseArea" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="配电房套数" prop="pdHouseNum">
          <el-input v-model="ruleForm.pdHouseNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="配电房面积(㎡)" prop="pdHouseArea">
          <el-input v-model="ruleForm.pdHouseArea" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>

        <el-form-item tem label="绿地面积(㎡)" prop="greenlandArea">
          <el-input v-model="ruleForm.greenlandArea" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="道路面积(㎡)" prop="roadArea">
          <el-input v-model="ruleForm.roadArea" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="电梯总数" prop="elevatorNum">
          <el-input v-model="ruleForm.elevatorNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="公建用地面积(㎡)" prop="publicLandArea">
          <el-input v-model="ruleForm.publicLandArea" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="绿地率(%)" prop="greenlandRate">
          <el-input v-model="ruleForm.greenlandRate" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
          <span style="color:red;margin-left:10px;">只填写数字即可，不需要填写‘%’，例：12.34</span>
        </el-form-item>
        <el-form-item tem label="容积率(%)" prop="volumeRate">
          <el-input v-model="ruleForm.volumeRate" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
          <span style="color:red;margin-left:10px;">只填写数字即可，不需要填写‘%’，例：12.34</span>
        </el-form-item>
        <el-form-item tem label="多层栋数" prop="dcHouseNum">
          <el-input v-model="ruleForm.dcHouseNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
          <span style="color:red;margin-left:10px;">楼高度27米及以下</span>
        </el-form-item>
        <el-form-item tem label="高层栋数" prop="gcHouseNum">
          <el-input v-model="ruleForm.gcHouseNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
          <span style="color:red;margin-left:10px;">27米<楼高度<=100米</span> </el-form-item> <el-form-item tem label="超高层栋数"
              prop="cgcHouseNum">
              <el-input v-model="ruleForm.cgcHouseNum" placeholder="请输入" class="item-input" type="number"
                maxlength="50">
              </el-input>
              <span style="color:red;margin-left:10px;">楼高度大于100米</span>
        </el-form-item>
        <el-form-item tem label="别墅栋数" prop="bsHouseNum">
          <el-input v-model="ruleForm.bsHouseNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="幼儿园个数" prop="kindergartenNum">
          <el-input v-model="ruleForm.kindergartenNum" placeholder="请输入" class="item-input" type="number"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="学校个数" prop="schoolNum">
          <el-input v-model="ruleForm.schoolNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="非机动车库个数" prop="noMotorizedGarageNum">
          <el-input v-model="ruleForm.noMotorizedGarageNum" placeholder="请输入" class="item-input" type="number"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="大门总数" prop="doorsNum">
          <el-input v-model="ruleForm.doorsNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="车位数" prop="parkingNum">
          <el-input v-model="ruleForm.parkingNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="地上车位总数" prop="onParkingNum">
          <el-input v-model="ruleForm.onParkingNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="地下车位总数" prop="unParkingNum">
          <el-input v-model="ruleForm.unParkingNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="晾衣竿个数" prop="clothesNum">
          <el-input v-model="ruleForm.clothesNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="消防通道数量" prop="evaNum">
          <el-input v-model="ruleForm.evaNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="消防栓总数" prop="hydrantNum">
          <el-input v-model="ruleForm.hydrantNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="可视监控摄像头总数" prop="cameraNum">
          <el-input v-model="ruleForm.cameraNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="电动汽车充电桩总数" prop="chargingPileNum">
          <el-input v-model="ruleForm.chargingPileNum" placeholder="请输入" class="item-input" type="number"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="健身器材个数" prop="sportNum">
          <el-input v-model="ruleForm.sportNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="儿童游乐设施个数" prop="childrenPlayNum">
          <el-input v-model="ruleForm.childrenPlayNum" placeholder="请输入" class="item-input" type="number"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="水箱个数" prop="waterTankNum">
          <el-input v-model="ruleForm.waterTankNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="蓄水池个数" prop="reservoirNum">
          <el-input v-model="ruleForm.reservoirNum" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>

        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isDisabled" @click="save('ruleForm')">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:gardenCompositionDetail
   *@Description:小区构成明细
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        isDisabled: true,
        saveData: '',
        id: '',
        rules: {
          residenceNum: [{
            required: true,
            message: '请输入住宅套数',
            trigger: 'blur'
          }],
          residenceArea: [{
            required: true,
            message: '请输入住宅面积',
            trigger: 'blur'
          }],
          notResidenceNum: [{
            required: true,
            message: '请输入非住宅套数',
            trigger: 'blur'
          }],
          notResidenceArea: [{
            required: true,
            message: '请输入非住宅面积',
            trigger: 'blur'
          }],
          wyHouseNum: [{
            required: true,
            message: '请输入物业管理用房套数',
            trigger: 'blur'
          }],
          wyHouseArea: [{
            required: true,
            message: '请输入物业管理用房面积',
            trigger: 'blur'
          }],
          pdHouseNum: [{
            required: true,
            message: '请输入配电房套数',
            trigger: 'blur'
          }],
          pdHouseArea: [{
            required: true,
            message: '请输入配电房面积',
            trigger: 'blur'
          }],
          greenlandArea: [{
            required: true,
            message: '请输入绿地面积',
            trigger: 'blur'
          }],
          roadArea: [{
            required: true,
            message: '请输入道路面积',
            trigger: 'blur'
          }],
          elevatorNum: [{
            required: true,
            message: '请输入电梯总数',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          residenceNum: '', // 住宅套数
          residenceArea: '', // 住宅面积
          notResidenceNum: '', // 非住宅套数
          notResidenceArea: '', // 非住宅面积
          wyHouseNum: '', // 物业管理用房套数
          wyHouseArea: '', // 物业管理用房面积
          pdHouseNum: '', // 配电房套数
          pdHouseArea: '', // 配电房面积
          greenlandArea: '', // 绿地面积
          roadArea: '', // 道路面积
          elevatorNum: '', // 电梯总数
          publicLandArea: '', // 公建用地面积
          greenlandRate: '', // 绿地率
          volumeRate: '', // 容积率
          dcHouseNum: '', // 多层栋数
          gcHouseNum: '', // 高层栋数
          cgcHouseNum: '', // 超高层栋数
          bsHouseNum: '', // 别墅栋数
          kindergartenNum: '', // 幼儿园个数
          schoolNum: '', // 学校个数
          noMotorizedGarageNum: '', // 非机动车库个数
          doorsNum: '', // 大门总数
          parkingNum: '', // 车位数
          onParkingNum: '', // 地上车位总数
          unParkingNum: '', // 地下车位总数
          clothesNum: '', // 晾衣竿个数
          evaNum: '', // 消防通道数量
          hydrantNum: '', // 消防栓总数
          cameraNum: '', // 可视监控摄像头总数
          chargingPileNum: '', // 电动汽车充电桩总数
          sportNum: '', // 健身器材个数
          childrenPlayNum: '', // 儿童游乐设施个数
          waterTankNum: '', // 水箱个数
          reservoirNum: '', // 蓄水池个数

        },
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 获取小区构成明细
      getData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawGardenForm?gardenId=${this.gardenId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.list.length > 0) {
                this.ruleForm.residenceNum = res.list[0].residenceNum
                this.ruleForm.residenceArea = res.list[0].residenceArea
                this.ruleForm.notResidenceNum = res.list[0].notResidenceNum
                this.ruleForm.notResidenceArea = res.list[0].notResidenceArea
                this.ruleForm.wyHouseNum = res.list[0].wyHouseNum
                this.ruleForm.wyHouseArea = res.list[0].wyHouseArea
                this.ruleForm.pdHouseNum = res.list[0].pdHouseNum
                this.ruleForm.pdHouseArea = res.list[0].pdHouseArea
                this.ruleForm.greenlandArea = res.list[0].greenlandArea
                this.ruleForm.roadArea = res.list[0].roadArea
                this.ruleForm.elevatorNum = res.list[0].elevatorNum
                this.ruleForm.publicLandArea = res.list[0].publicLandArea
                this.ruleForm.greenlandRate = res.list[0].greenlandRate
                this.ruleForm.volumeRate = res.list[0].volumeRate
                this.ruleForm.dcHouseNum = res.list[0].dcHouseNum
                this.ruleForm.gcHouseNum = res.list[0].gcHouseNum
                this.ruleForm.cgcHouseNum = res.list[0].cgcHouseNum
                this.ruleForm.bsHouseNum = res.list[0].bsHouseNum
                this.ruleForm.kindergartenNum = res.list[0].kindergartenNum
                this.ruleForm.schoolNum = res.list[0].schoolNum
                this.ruleForm.noMotorizedGarageNum = res.list[0].noMotorizedGarageNum
                this.ruleForm.doorsNum = res.list[0].doorsNum
                this.ruleForm.parkingNum = res.list[0].parkingNum
                this.ruleForm.onParkingNum = res.list[0].onParkingNum
                this.ruleForm.unParkingNum = res.list[0].unParkingNum
                this.ruleForm.clothesNum = res.list[0].clothesNum
                this.ruleForm.evaNum = res.list[0].evaNum
                this.ruleForm.hydrantNum = res.list[0].hydrantNum
                this.ruleForm.cameraNum = res.list[0].cameraNum
                this.ruleForm.chargingPileNum = res.list[0].chargingPileNum
                this.ruleForm.sportNum = res.list[0].sportNum
                this.ruleForm.childrenPlayNum = res.list[0].childrenPlayNum
                this.ruleForm.waterTankNum = res.list[0].waterTankNum
                this.ruleForm.reservoirNum = res.list[0].reservoirNum
                this.id = res.list[0].id
                // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
                this.saveData = JSON.stringify(this.ruleForm)
                console.log(this.ruleForm)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 保存
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              // 新增
              this.$post('/gardenDrawGardenForm', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/gardenDrawGardenForm/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.ruleForm.residenceNum = ''
        this.ruleForm.residenceArea = ''
        this.ruleForm.notResidenceNum = ''
        this.ruleForm.notResidenceArea = ''
        this.ruleForm.wyHouseNum = ''
        this.ruleForm.wyHouseArea = ''
        this.ruleForm.pdHouseNum = ''
        this.ruleForm.pdHouseArea = ''
        this.ruleForm.greenlandArea = ''
        this.ruleForm.roadArea = ''
        this.ruleForm.elevatorNum = ''
        this.ruleForm.publicLandArea = ''
        this.ruleForm.greenlandRate = ''
        this.ruleForm.volumeRate = ''
        this.ruleForm.dcHouseNum = ''
        this.ruleForm.gcHouseNum = ''
        this.ruleForm.cgcHouseNum = ''
        this.ruleForm.bsHouseNum = ''
        this.ruleForm.kindergartenNum = ''
        this.ruleForm.schoolNum = ''
        this.ruleForm.noMotorizedGarageNum = ''
        this.ruleForm.doorsNum = ''
        this.ruleForm.parkingNum = ''
        this.ruleForm.onParkingNum = ''
        this.ruleForm.unParkingNum = ''
        this.ruleForm.clothesNum = ''
        this.ruleForm.evaNum = ''
        this.ruleForm.hydrantNum = ''
        this.ruleForm.cameraNum = ''
        this.ruleForm.chargingPileNum = ''
        this.ruleForm.sportNum = ''
        this.ruleForm.childrenPlayNum = ''
        this.ruleForm.waterTankNum = ''
        this.ruleForm.reservoirNum = ''
      }

    },
  }
</script>

<style lang="scss">
  .gardenCompositionDetail {

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>